export default __webpack_public_path__ + "static/Graphik-SemiboldItalic-Web-6f90f1a29bc5b953adfc02f85e1be75f.ttf";